module.exports = __webpack_public_path__ + "8b7a8e83b8fab08a9f6d215760449c00.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/videos/lifeQuestionQ1.mp4
// module id = 410
// module chunks = 0